// Auth is handled via Firebase (see AuthContext.jsx).
// This file keeps formatApiErrorDetail used by Login/Register pages.

export function formatApiErrorDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Legacy stubs — no longer used but kept to avoid import errors in older pages
export const getToken = () => null;
export const setToken = () => {};
export const apiLogin = async () => { throw new Error("Use AuthContext.login()"); };
export const apiLogout = async () => {};
export const apiMe = async () => { throw new Error("Use AuthContext"); };
export const apiRegister = async () => { throw new Error("Registration disabled"); };
